import React from 'react'
import styled from 'styled-components'
import P from '../components/p'
import TransitionLinkUnstyled from 'gatsby-plugin-transition-link'
import Underlined from '../components/underlined'

const StyledPost = styled.div`
  margin: 3rem 0 3rem;
  padding: 3rem;
`

const TransitionLink = styled(TransitionLinkUnstyled)`
  text-decoration: none;
  color: #171d20;
  display: inline-block;
`

const Title = styled.h1`
  font-size: 60px;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  z-index: 2;
  @media (max-width: 900px) {
    font-size: 38px;
    letter-spacing: 0px;
  }
`

const Post = ({ node }) => (
  <StyledPost>
    <Title>
      <TransitionLink
        to={node.frontmatter.path}
        exit={{
          length: 0.4,
        }}
        entry={{
          delay: 0.3,
          length: 0.8,
        }}
      >
        <Underlined>{node.frontmatter.title}</Underlined>
      </TransitionLink>
    </Title>
    <P>{node.excerpt}</P>
  </StyledPost>
)

export default Post
